module.exports = __webpack_public_path__ + "static/media/luong-gio-ba-chieu.adcfb11e.svg";